addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-bulk]').forEach(form => {
        const items = Array.from(form.querySelectorAll('[data-product-bulk-item]'));
        const allToggles = form.querySelectorAll('[data-product-bulk-all]');
        const submit = form.querySelector('[data-product-bulk-submit]');
        const count = form.querySelector('[data-product-bulk-count]');
        if (!items.length) return;

        // The desktop table and mobile cards each carry a checkbox per product; keep them in step.
        const total = new Set(items.map(item => item.value)).size;
        const update = () => {
            const selected = new Set(items.filter(item => item.checked).map(item => item.value)).size;
            allToggles.forEach(toggle => {
                toggle.checked = selected === total;
                toggle.indeterminate = selected > 0 && selected < total;
            });
            if (submit) submit.disabled = selected === 0;
            if (count) count.textContent = selected ? '(' + selected + ')' : '';
        };

        items.forEach(item => item.addEventListener('change', () => {
            items.filter(other => other.value === item.value).forEach(other => { other.checked = item.checked; });
            update();
        }));
        allToggles.forEach(toggle => toggle.addEventListener('change', () => {
            items.forEach(item => { item.checked = toggle.checked; });
            update();
        }));
        update();
    });
});
